<template>
  <el-row class="container-card el-row">
    <Channels />
  </el-row>
</template>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
import Channels from '../components/Table'

export default {
  components: {
    Channels
  },

  computed: {
    ...mapGetters('auth', ['artist_role']),
    ...mapState('auth', ['user'])
  },

  methods: {
    ...mapMutations('artistDashboard', ['setSelectedArtist'])
  },

  mounted() {
    if (this.artist_role) {
      this.setSelectedArtist(null)
    }
  }
}
</script>
